import React from "react";
import { useAuth } from "../context/AuthContext";
import Layout from "../components/Layout";
import AffiliateDashboard from "./affiliate";
import CommercialDashboard from "./commercial";
import AdminDashboard from "./admin";

const Dashboard: React.FC = () => {
  const { currentRole } = useAuth();

  const renderDashboard = () => {
    switch (currentRole) {
      case "admin":
        return <AdminDashboard />;
      case "commercial":
        return <CommercialDashboard />;
      case "user":
      default:
        return <AffiliateDashboard />;
    }
  };

  return <Layout>{renderDashboard()}</Layout>;
};

export default Dashboard;
